<script>
  import {createEventDispatcher, tick} from 'svelte'

  export let width
  export let height
  export let id
  
  const dispatch = createEventDispatcher()

  if(width === undefined || width <= 0) width = 100
  if(height === undefined || height <= 0) height = 100

  const symbolWidth = 22
  const symbolHeight = 49
  const scale = 1
  const tileScale = 1
  const redYPct = 0.65
  const redXPct = 0.3
  const threshold = 0.03

  $: tileWidth = symbolWidth * tileScale
  $: tileHeight = symbolHeight * tileScale
  
  $: cols = Math.ceil(width / tileWidth)
  $: rows = Math.floor(height / tileHeight)
  $: offsetX = ((cols * tileWidth) - width) / 2
  $: if(width) {
    tick().then(() => {
      dispatch('redraw', true)
    })
  }
  $: peopleByRow = Array.from(Array(rows).keys()).map(i => {
    let hasRed = false
    return {
      index: i,
      cols: Array.from(Array(cols).keys()).map(j => {
        let isRed = hasRed ? false : (i / rows) >= (redYPct - threshold) && (i / rows) <= (redYPct + threshold) && (j / cols) >= (redXPct - threshold) && (j / cols) <= (redXPct + threshold)
        if(isRed) hasRed = true
        return {
          index: j,
          totalIndex: cols * i + j,
          isMan: (cols * i + j + (cols % 2 == 0 ? i % 2 : 0)) % 2 == 0,
          isRed
        }
      })
    }
  })

  function shouldBeRed (row, col) {
    const rowPct = row / rows
    const colPct = col / cols
    return rowPct >= (redYPct - threshold) && rowPct <= (redYPct + threshold) && colPct >= (redXPct - threshold) && colPct <= (redXPct + threshold)
  }

</script>

<svg {id} width={width} height={height} viewBox="0 0 {width} {height}" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <symbol id="person-man" viewBox="0 0 {symbolWidth} {symbolHeight}">
      <g fill="currentColor" transform="translate({(1 - scale) * symbolWidth/2}, {(1 - scale) * symbolHeight/2}) scale({scale})">
        <path d="M15.745 6.23187H14.5018H14.3092H7.52427H7.3307H6.08782C5.21163 6.23187 4.5 6.94284 4.5 7.81903V7.84145V10.4436V19.3001C4.5 19.9372 5.06522 20.4549 5.76234 20.4549H5.78773C6.48452 20.4549 7.04974 19.9372 7.04974 19.3001V10.2283C7.11173 10.2148 7.1767 10.2059 7.24331 10.2059C7.27332 10.2059 7.30102 10.2105 7.3307 10.2128V18.2089V19.773V33.5697C7.3307 34.4435 8.0387 35.1532 8.91258 35.1532H8.94423C9.81877 35.1532 10.5271 34.4442 10.5271 33.5697V19.7473C10.6396 19.6731 10.7715 19.6285 10.9169 19.6285C11.0616 19.6285 11.1945 19.6744 11.3073 19.7486C11.3073 19.7628 11.3053 19.7763 11.3053 19.7905V33.5697C11.3053 34.4432 12.0137 35.1529 12.8872 35.1529H12.9199C13.7941 35.1529 14.5031 34.4442 14.5031 33.5697V19.7905C14.5031 19.7845 14.5018 19.7792 14.5018 19.773H14.5031V10.2125C14.5327 10.2098 14.5604 10.2055 14.5914 10.2055C14.6584 10.2055 14.722 10.2144 14.7853 10.228V19.2998C14.7853 19.9369 15.3502 20.4546 16.0474 20.4546H16.0727C16.7695 20.4546 17.3338 19.9369 17.3338 19.2998V10.4433V7.84112V7.8187C17.3324 6.94284 16.6225 6.23187 15.745 6.23187Z"/>
        <path d="M13.7571 2.84026C13.7571 4.40994 12.4852 5.68052 10.9165 5.68052C9.3475 5.68052 8.07692 4.40961 8.07692 2.84026C8.07692 1.27256 9.34783 0 10.9165 0C12.4849 0 13.7571 1.27256 13.7571 2.84026Z"/>
      </g>
    </symbol>
    <symbol id="person-woman" viewBox="0 0 {symbolWidth} {symbolHeight}">
      <g fill="currentColor" transform="translate({(1 - scale) * symbolWidth/2}, {(1 - scale) * symbolHeight/2}) scale({scale})">
        <path d="M18.6278 16.7845L15.9142 7.47758C15.6566 6.59546 14.8487 5.98804 13.929 5.98804H13.1524H11.0841H9.01616H8.23924C7.32051 5.98804 6.51193 6.59546 6.25472 7.47758L3.54108 16.7845C3.36334 17.3956 3.78214 18.0175 4.41496 18.0831L4.67877 18.1089C5.17342 18.1586 5.63278 17.8447 5.76238 17.3646L7.76635 10.0346C7.76635 10.0346 7.8887 9.92674 8.03017 9.93334L4.62007 23.5707H8.05688V33.5586C8.05688 34.3563 8.62308 35.0023 9.32086 35.0023H9.34593C10.0447 35.0023 10.6096 34.3563 10.6096 33.5586V23.5707H11.0838H11.558V33.5586C11.558 34.3563 12.1242 35.0023 12.8223 35.0023H12.8474C13.5461 35.0023 14.111 34.3563 14.111 33.5586V23.5707H17.5478L14.1387 9.93334C14.2792 9.92641 14.4029 10.0346 14.4029 10.0346L16.4052 17.3646C16.5361 17.8447 16.9958 18.1586 17.4898 18.1089L17.7539 18.0831C18.3864 18.0175 18.8062 17.3952 18.6278 16.7845Z"/>
        <path d="M11.0842 5.51493C12.5834 5.51493 13.7988 4.29956 13.7988 2.80031C13.7988 1.30107 12.5834 0.0856934 11.0842 0.0856934C9.58496 0.0856934 8.36958 1.30107 8.36958 2.80031C8.36958 4.29956 9.58496 5.51493 11.0842 5.51493Z"/>
      </g>
    </symbol>
  </defs>
  {#each peopleByRow as row (row)}
    <g>
      {#each row.cols as col (col)}
        <svg class="person" class:red={col.isRed} id="people-tile_{col.totalIndex}" x="{col.index * tileWidth - offsetX}" y="{ row.index * tileHeight}" width="{tileWidth}" height="{tileHeight}"><use xlink:href="#person-{col.isMan ? 'man' : 'woman'}" /></svg>
      {/each}
    </g>
  {/each}
</svg>

<style>
  .person.red {
    color: var(--verizon-red)
  }
</style>